import { render } from "./DashboardBuildingPage.vue?vue&type=template&id=ef539e10&scoped=true"
import script from "./DashboardBuildingPage.vue?vue&type=script&lang=js"
export * from "./DashboardBuildingPage.vue?vue&type=script&lang=js"

import "./DashboardBuildingPage.vue?vue&type=style&index=0&id=ef539e10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef539e10"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader});
